module.exports = __webpack_public_path__ + "static/img/050603.014ae7ee.png";